import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { useForm } from "../../../../system/hooks/useForm";
import { IActDeductionReducerInitialState } from "../state/ActDeductionReducer";


interface IInvoiceOutValidateModel {
    documentDate: DateTime
    idStoreGlobal?: string
    idContractorToGlobal?: string
    reason?: string
    kizDestructionType?: string
    kizMoveDestructionContractor?: string
    kizDestructionMethod?: string
    kizMoveDestructionDocNum?: string
    kizDestructionDocNum?: string
    kizMoveDestructionActNum?: string
    kizDestructionDocDate?: DateTime
    kizMoveDestructionFiasAoguid?: string

}

export const useActDeductionValidator = (entity:  IActDeductionReducerInitialState, isSentDocument: boolean = false) => {
    const { t } = useTranslation();
    const errorsT = (value: string) => t('errors.' + value);




    return useForm<IInvoiceOutValidateModel>({
        validations: {
            documentDate: {
                required: {
                    value: entity?.data?.documentDate?.day ? false : true,
                    message: errorsT("required")
                }
            },
            idStoreGlobal: {
                required: {
                    value: entity?.data?.idStoreGlobal ? false : true,
                    message: errorsT("required")
                }
            },
            reason: {
                required: {
                    value: entity?.data?.kizDestructionOp ? (entity?.data?.idDeductionReasonGlobal ? false : true) : false,
                    message: errorsT("required")
                }
            },
            kizDestructionType: {
                required: {
                    value: entity?.data?.kizDestructionOp ? (entity?.data?.idKizDestructionType ? false : true) : false,
                    message: errorsT("required")
                }
            },
            kizMoveDestructionContractor: {
                required: {
                    value: entity?.data?.kizDestructionOp ? (entity?.data?.idKizMoveDestructionContractor ? false : true) : false,
                    message: errorsT("required")
                }
            },
            kizDestructionMethod: {
                required: {
                    value: isSentDocument ? (entity?.data?.idKizDestructionMethod ? false : true) : false,
                    message: errorsT("required")
                }
            },
            kizMoveDestructionDocNum: {
                required: {
                    value: entity?.data?.kizDestructionOp ? (entity?.data?.kizMoveDestructionDocNum ? false : true) : false,
                    message: errorsT("required")
                }
            },
            kizDestructionDocNum: {
                required: {
                    value: isSentDocument ? (entity?.data?.kizDestructionDocNum ? false : true) : false,
                    message: errorsT("required")
                }
            },
            kizMoveDestructionActNum: {
                required: {
                    value: entity?.data?.kizDestructionOp ? (entity?.data?.kizMoveDestructionActNum ? false : true) : false,
                    message: errorsT("required")
                }
            },
            kizDestructionDocDate: {
                required: {
                    value: isSentDocument ? (entity?.data?.kizDestructionDocDate ? false : true) : false,
                    message: errorsT("required")
                }
            },
            kizMoveDestructionFiasAoguid: {
                required: {
                    value: entity?.reasonMode === "DROP" ? (entity?.data?.kizMoveDestructionFiasAoguid ? false : true) : false,
                    message: errorsT("required")
                },
                custom: {
                    // при причине списания DROP код ФИАС должен быть корректным GUID (пустоту обрабатывает правило required)
                    isValid: () => {
                        const value = entity?.data?.kizMoveDestructionFiasAoguid;
                        if (entity?.reasonMode !== "DROP" || !value) return true;
                        return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(value);
                    },
                    message: errorsT("invalidGuid")
                }
            },
        },
    });
}

export default useActDeductionValidator
